import {useContext, useState} from "react";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import PrintIcon from '@mui/icons-material/Print';
import {useProject, useProjectId} from "../../shopdrawing/ProjectName";
import {api} from "../../../../api/API";
import {PrintManagerContext} from "../../../../misc/pdf/PrintManager";
import {useIsQuote} from "../QuoteContainer";
import {useAlternative} from "../alternative/Alternative";
import {hardwareSchedulePDF} from "./HardwareSchedulePDF";
import {convertHardwareForViewMode, filterHardwareByPhase} from "../../shopdrawing/hardware/WorkingHardware";
import {ViewMode} from "./HardwareViewMode";
import {CustomizeHardwareSchedule, HardwarePageItem} from "./CustomizeHardwareSchedule";
import {Contact} from "../../../../api/Contacts";
import {Company} from "../../../../api/Companies";
import {OpeningWithSelected} from "../../shopdrawing/openings/pdf/OpeningsTab";

export function HardwareScheduleBtn() {
    const project = useProject();
    const projectId = useProjectId();

    const printCtx = useContext(PrintManagerContext);
    const alternative = useAlternative();
    const isQuote = useIsQuote();
    const [show, setShow] = useState(false)

    return (<>
        <SmallGreyButton startIcon={<PrintIcon />} onClick={() => setShow(true)}>HW Schedule</SmallGreyButton>
        {show && <CustomizeHardwareSchedule onHide={() => setShow(false)} submit={async (config: {
            viewMode: ViewMode;
            pages: HardwarePageItem[];
            client: Company;
            clientContact: Contact;
            openings: OpeningWithSelected[];
            preamble: string;
            lastSubmission: string | null;
            splitByPhase: boolean;
            phases: string[];
        }) => {
            if(!project) return;

            let hw = isQuote ? await api.quoteHardware.listWithContents({
                    project: projectId, alternative: alternative,
                })
                : await api.hardware.listWithContents({
                    project: projectId,
                })

            hw = convertHardwareForViewMode(hw, config.viewMode, config.openings);
            hw = filterHardwareByPhase(hw, config.phases);

            await printCtx.print2(hardwareSchedulePDF({
                preamble: config.preamble,
                lastSubmittal: config.lastSubmission,
                project: project,
                client: config.client,
                clientContact: config.clientContact,
                hardware: hw,
                pages: config.pages,
                viewMode: config.viewMode,
                splitByPhase: config.splitByPhase,
            }))
        }} />}
    </>)
}